import { useFlightsSearch } from "@lib/context/flights/search-context";
import { useCallback } from "react";

/**
 * Custom hook for managing flight-specific origin and destination selections
 * This provides a cleaner interface for handling multiple flights in the mobile flow
 */
export const useFlightSelection = flightIndex => {
  const {
    search,
    setSearch,
    updateFlightInfo,
    currentFlightIndex,
    setCurrentFlightIndex
  } = useFlightsSearch();

  // Get the current flight info
  const currentFlight = (search === null || search === void 0 ? void 0 : search.flight_info.find(flight => flight.id === flightIndex + 1)) || (search === null || search === void 0 ? void 0 : search.flight_info[flightIndex]) || {
    id: flightIndex + 1,
    origin_iata: "",
    flight_type_origin: undefined,
    origin: "",
    flight_type_destination: undefined,
    destination_iata: "",
    destination: "",
    departure_date: undefined,
    return_date: undefined
  };

  // Update origin for the specific flight
  const updateOrigin = useCallback(originOption => {
    const flightId = currentFlight.id;
    updateFlightInfo(flightId, {
      flight_type_origin: originOption.value,
      origin: originOption.title,
      origin_iata: originOption.id
    });
  }, [updateFlightInfo, currentFlight.id]);

  // Update destination for the specific flight
  const updateDestination = useCallback(destinationOption => {
    const flightId = currentFlight.id;
    updateFlightInfo(flightId, {
      flight_type_destination: destinationOption.value,
      destination: destinationOption.title,
      destination_iata: destinationOption.id
    });
  }, [updateFlightInfo, currentFlight.id]);

  // Set this flight as the current one being edited
  const setAsCurrentFlight = useCallback(() => {
    setCurrentFlightIndex(flightIndex);
  }, [setCurrentFlightIndex, flightIndex]);

  // Check if this is the currently selected flight
  const isCurrentFlight = currentFlightIndex === flightIndex;
  return {
    currentFlight,
    updateOrigin,
    updateDestination,
    setAsCurrentFlight,
    isCurrentFlight
  };
};